import React from "react";

export default function ReportsSidebarRows({
  name,
  icon,
  active,
  setActive,
  setType,
  filterType,
}) {
  const activeReport = (type) => {
    if (type !== active) {
      setActive(type);
      setType(type);
    }
  };
  return (
    <div>
      <div
        className={`reports-sidebar-types-row ${
          active === filterType ? "active" : ""
        }`}
        onClick={() => {
          activeReport(filterType);
          setType(filterType);
        }}
      >
        <img
          src={
            active === filterType
              ? `assets/Reports/Active/${icon}.svg`
              : `assets/Reports/${icon}.svg`
          }
          alt={filterType}
        />
        <div>{name}</div>
      </div>
    </div>
  );
}
